import { render, staticRenderFns } from "./AmerceSelect.vue?vue&type=template&id=22e34235&"
import script from "./AmerceSelect.vue?vue&type=script&lang=js&"
export * from "./AmerceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports